export default __webpack_public_path__ + "static/media/6Loop.3c280264.mp4";